import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const FamiliesChartsDataContext = createContext();

const FamiliesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.FAMILIES_MAPPING,
            url: 'governanceroom/dashboard/unifiedregistry/mapping/families'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  familiesRegistered: data?.indicators?.familiesRegistered ?? 0,
                  peopleRegistered: data?.indicators?.peopleRegistered ?? 0,
                  averagePeoplePerFamily:
                      data?.indicators?.averagePeoplePerFamily ?? 0
              },
              people: data?.people ?? [],
              families: data?.families ?? [],
              averagePeoplePerFamily: data?.averagePeoplePerFamily ?? [],
              familiesMap: data?.familiesMap ?? []
          }
        : {
              indicators: {
                  familiesRegistered: 0,
                  peopleRegistered: 0,
                  averagePeoplePerFamily: 0
              },
              people: [],
              families: [],
              averagePeoplePerFamily: [],
              familiesMap: []
          };

    return (
        <FamiliesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </FamiliesChartsDataContext.Provider>
    );
};

export default FamiliesChartsDataProvider;
